import { ExchangeApiUrls } from "@/modules/exchangeRate/common/enum";
import type {
  ExchangeRateCredentials,
  ExchangeRateResponse,
} from "@/modules/exchangeRate/common/types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const exchangeRateApi = createApi({
  reducerPath: "exchangeRateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getExchangeRates: builder.query<ExchangeRateResponse, ExchangeRateCredentials>({
      query: ({ type }) => ({
        url: `${ExchangeApiUrls.ExchangeRates}?type=${type}`,
      }),
    }),
  }),
});

export const { useGetExchangeRatesQuery } = exchangeRateApi;
